module.exports = __webpack_public_path__ + "static/media/internalBranding.df0eda51.jpg";